module.exports = __webpack_public_path__ + "img/fangzhen.6912acb5.png";